import {useSelector} from "react-redux";

import {useOpenPricesExperiment} from "../ab_testing/hooks/use_open_prices_experiment";
import {IRPStore} from "../app/rp_reducer";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {checkHasCompleteProfile} from "../user/utils/check_has_complete_profile";
import {checkHasVerifiedPhone} from "../user/utils/check_has_verified_phone";

export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);
    const {isOpenPricesVariant} = useOpenPricesExperiment();

    const hasCompleteProfile = checkHasCompleteProfile(userInfo);
    const hasPhoneVerified = checkHasVerifiedPhone(userInfo);
    const isUserLoggedIn = Boolean(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    // 3. OR user is assigned to the open-prices test variant
    return {
        shouldHidePrices: !isOpenPricesVariant && (!hasCompleteProfile || !hasPhoneVerified) && !isPricesUnlocked,
        hasCompleteProfile,
        hasPhoneVerified: hasPhoneVerified,
        isUserLoggedIn,
        isOpenPricesVariant
    };
};
import {useSelector} from "react-redux";

import {useOpenPricesExperiment} from "../ab_testing/hooks/use_open_prices_experiment";
import {IRPStore} from "../app/rp_reducer";
import {useGetUserProfileQuery} from "../user/api/get_user_profile";
import {checkHasCompleteProfile} from "../user/utils/check_has_complete_profile";
import {checkHasVerifiedPhone} from "../user/utils/check_has_verified_phone";

export const useShouldHidePrices = () => {
    const {data: userInfo} = useGetUserProfileQuery();
    const isPricesUnlocked = useSelector((state: IRPStore) => state.pricesUnlocked.isUnlocked);
    const {isOpenPricesVariant} = useOpenPricesExperiment();

    const hasCompleteProfile = checkHasCompleteProfile(userInfo);
    const hasPhoneVerified = checkHasVerifiedPhone(userInfo);
    const isUserLoggedIn = Boolean(userInfo);

    // Prices should be shown if:
    // 1. User has complete profile (authenticated with name and phone)
    // 2. OR prices have been manually unlocked (e.g., after sending a lead)
    // 3. OR user is assigned to the open-prices test variant
    return {
        shouldHidePrices: !isOpenPricesVariant && (!hasCompleteProfile || !hasPhoneVerified) && !isPricesUnlocked,
        hasCompleteProfile,
        hasPhoneVerified: hasPhoneVerified,
        isUserLoggedIn,
        isOpenPricesVariant
    };
};
